export const sectionOneImages: string[] = [
    "https://devminds.co.in/assets/img/eventena/event1.jpg",
    "https://devminds.co.in/assets/img/eventena/event2.jpg",
    "https://devminds.co.in/assets/img/eventena/event3.jpg",
    "http://eventena.in/assets/images/sectionOneImg4.jpg",
    "http://eventena.in/assets/images/sectionOneImg5.jpg",
    "http://eventena.in/assets/images/sectionOneImg8.jpg",
    "http://eventena.in/assets/images/sectionOneImg7.jpg"
];
